import { isJSXElement } from "@utils/common";
import { CSSProperties, FC } from "react";
import { LuArrowUpRight } from "react-icons/lu";
import { GBButton, GBButtonWithIcon } from "./new-ui/CTAButtons";

export interface CardStylesProps extends CSSProperties {
    cardColor?: string;
    cardTextColor?: string;
    buttonTextColor?: string;
    buttonBackgroundColor?: string;
    buttonHoverColor?: string;
    secondaryButtonTextColor?: string;
    secondaryButtonBackgroundColor?: string;
    secondaryButtonBorderColor?: string;
}

interface YellowCTAHrefProps {
    ctaTrackId?: string;
    customText?: JSX.Element | string;
    link1?: string;
    link2?: string;
    buttonText?: string;
    secondaryButtonText?: string;
    text2?: string;
    cardStyles?: CardStylesProps;
    buttonStyles?: CSSProperties;
    target?: string;
    buttonWithoutIcon?: boolean;
    containerClassName?: string;
    onButtonClick?: (e: React.MouseEvent) => void;
    buttonVariant?: "primary-light" | "primary-dark" | "secondary-light" | "secondary-dark";
}

const YellowCTAhref: FC<YellowCTAHrefProps> = (props) => {
    const {
        customText = "Get a demo customized to your institution workflow",
        link1 = "https://app.gallabox.com/signup",
        link2,
        buttonText = "Start your 7-day trial",
        secondaryButtonText = "Schedule a Demo",
        text2,
        cardStyles = {},
        buttonStyles = {},
        target = "_blank",
        ctaTrackId,
        buttonWithoutIcon,
        containerClassName,
        onButtonClick,
        buttonVariant = "primary-light",
    } = props;

    const {
        cardColor = " #feee95",
        cardTextColor = "text-yellow-800",
        secondaryButtonBackgroundColor = "bg-white",
        secondaryButtonTextColor = "text-blue-600",
        secondaryButtonBorderColor = "border-blue-600",
        ...cardStyleProps
    } = cardStyles;

    return (
        <section className={containerClassName ?? "py-10 lg:px-0 px-3"}>
            <div
                className={"max-w-7xl mx-auto  text-center rounded-xl md:rounded-lg flex flex-col gap-4 lg:py-10 lg:pb-4 px-5 py-8"}
                style={{ background: cardColor, ...cardStyleProps }}
            >
                {isJSXElement(customText) ? customText : <div className={`text-2xl md:text-3xl font-bold mb-4 relative inline-block ${cardTextColor}`}>{customText}</div>}

                <div className="flex md:justify-center md:flex-row text-lg md:px-6 gap-x-3 md:gap-x-6" style={{ ...buttonStyles }}>
                    {onButtonClick ? (
                        <>
                            {buttonWithoutIcon ? (
                                <GBButton onClick={onButtonClick} style={{ cursor: "pointer" }} variant={buttonVariant}>
                                    {buttonText}
                                </GBButton>
                            ) : (
                                <GBButtonWithIcon onClick={onButtonClick} rightIcon={LuArrowUpRight} style={{ cursor: "pointer" }}>
                                    {buttonText}
                                </GBButtonWithIcon>
                            )}
                        </>
                    ) : (
                        <>
                            {buttonWithoutIcon ? (
                                <GBButton href={link1} target={target}>
                                    {buttonText}
                                </GBButton>
                            ) : (
                                <GBButtonWithIcon href={link1} target={target} rightIcon={LuArrowUpRight}>
                                    {buttonText}
                                </GBButtonWithIcon>
                            )}
                        </>
                    )}
                    {link2 && (
                        <a
                            id={ctaTrackId}
                            href={link2}
                            target="_blank"
                            rel="noreferrer"
                            className={`px-4 py-2 text-base font-medium rounded-md hover:no-underline focus:outline-none ${secondaryButtonTextColor} hover:shadow-2xl ${secondaryButtonBackgroundColor} transition duration-300 ease-in-out   border border-solid ${secondaryButtonBorderColor} `}
                        >
                            {secondaryButtonText}
                        </a>
                    )}
                </div>
                {text2 && <div className={`text-sm ${cardTextColor}`}>{text2}</div>}
            </div>
        </section>
    );
};

export default YellowCTAhref;
